var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-btn',{on:{"click":_vm.test}},[_vm._v(" test ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }